module.exports = __webpack_public_path__ + "img/yiduiyi02.bd6f8186.jpg";